<script lang="ts" setup></script>
<template>
	<main class="h-dvh flex justify-center items-center md:bg-gray-300">
		<div class="w-full md:w-[55%] lg:w-[45%] xl:w-[40%] 2xl:w-[30%] md:p-12 rounded-lg md:shadow-lg md:bg-white">
			<slot />
		</div>
	</main>
</template>
